import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[muniSharedPopupDraggable]'
})
export class PopupDraggableDirective {
  @Input() popupDraggable: HTMLElement;
  private isDragging = false;
  private offsetX = 0;
  private offsetY = 0;

  constructor(private el: ElementRef) {
    this.el.nativeElement.style.position = 'absolute';
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(popupElement: HTMLElement, event: MouseEvent): void {
    if (
      event.target instanceof HTMLElement &&
      ['INPUT', 'TEXTAREA', 'SELECT', 'BUTTON'].includes(event.target.tagName)
    ) {
      return;
    }
    this.isDragging = true;
    this.offsetX = event.clientX - popupElement.getBoundingClientRect().left;
    this.offsetY = event.clientY - popupElement.getBoundingClientRect().top;
  }

  @HostListener('document:mouseup')
  onMouseUp(): void {
    this.isDragging = false;
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(popupElement: HTMLElement, event: MouseEvent): void {
    if (this.isDragging) {
      popupElement.style.position = 'absolute';
      popupElement.style.left = `${event.clientX - this.offsetX}px`;
      popupElement.style.top = `${event.clientY - this.offsetY}px`;
    }
  }
}
